import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "../../api/Api.js";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import { useNavigate } from "react-router-dom";
import "./VisaAssistanceAdd.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Underline,
  Font,
  Alignment,
  List,
  Link as CKLink,        // ✅ rename to avoid collision
  BlockQuote,
  Table as CKTable,
  TableToolbar,
  Image as CKImage,
  ImageUpload,
  ImageToolbar,
  ImageStyle,
  ImageResize,
  SimpleUploadAdapter,
  HorizontalLine,
} from "ckeditor5";
import "ckeditor5/ckeditor5.css";
const AddBlogPage = () => {
const navigate = useNavigate();
  // =========================
  // STATE
  // =========================
const [isSubmitting, setIsSubmitting] = useState(false);
const [title, setTitle] = useState("");
const [sbTitle, setSbTitle] = useState("");
const [description, setDescription] = useState("");
const [getYoutubeLink, setYoutubeLink] = useState("");
const [content, setContent] = useState("");
const [metaKey, setMetaKey] = useState("");
const [metaDescription, setMetaDescription] = useState("");
const [keyword, setKeyword] = useState("");
const [pageimg, setPageimg] = useState([]);
const [preview, setPreview] = useState([]);
const [addedBy, setaddedBy] = useState("");
const [tabChecks, setTabChecks] = useState({});
const [tabContents, setTabContents] = useState({});
  // EXTRA IMAGE TABLE
  const [imageRows, setImageRows] = useState([
    {
      image: null,
      preview: "",
      altTitle: ""
    }
  ]);
  const [faqRows, setFaqRows] = useState([
  {
    question: "",
    answer: ""
  }
]);


  const [categories, setCategories] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
   const [updatedDate, setUpdatedDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [getSratingPrice, setSratingPrice] = useState("");
  const [getProcessTime, setProcessTime] = useState("");
  const [getHourDays, setHourdays] = useState("");

  // =========================
  // CLEANUP IMAGE URL
  // =========================

  useEffect(() => {

    return () => {
      preview.forEach((url) => URL.revokeObjectURL(url));

      imageRows.forEach((row) => {
        if (row.preview) {
          URL.revokeObjectURL(row.preview);
        }
      });
    };

  }, [preview, imageRows]);

  useEffect(() => {
      fetchCategoryData();
      fetchTabData();
  }, []);


   useEffect(() => {
    if (tabs.length > 0) {
      setActiveTab(tabs[0].tab_id);
    }
  }, [tabs]);

  const fetchCategoryData = async () => {
    try {
      const res = await api.get("/adminVisaAssistanc/getContryDataVisa");
      setCategories(res.data?.data || []);
    } catch (error) {
      toast.error("Failed to load Contry data");
    }
  };

const fetchTabData = async () => {
    try {
      const res = await api.get("/adminVisaAssistanc/getTabataVisa");
      setTabs(res.data?.data || []);
      
  if (res.length > 0) {
    setActiveTab(res[0].tab_id);
  }
    } catch (error) {
      toast.error("Failed to load Tab data");
    }
  };

const handleTagChange = (slug) => {

  setSelectedTags((prev) =>

    prev.includes(slug)
      ? prev.filter((tag) => tag !== slug)
      : [...prev, slug]

  );

};

  // =========================
  // MAIN IMAGE CHANGE
  // =========================

  const handleImageChange = (e) => {

    const files = Array.from(e.target.files);

    setPageimg(files);

    const previewUrls = files.map((file) =>
      URL.createObjectURL(file)
    );

    setPreview(previewUrls);

  };

const visaLink = title
                  .toLowerCase()
                  .trim()
                  .replace(/[^\w\s-]/g, "")
                  .replace(/\s+/g, "-");

useEffect(() => {
  setImageRows((prev) =>
    prev.map((row, index) => ({
      ...row,
      altTitle: visaLink
        ? `${visaLink}-${index + 1}`
        : ""
    }))
  );
}, [visaLink]);

  // =========================
  // DELETE PREVIEW IMAGE
  // =========================

  const handleDeletePreviewImage = async (index) => {

    const confirm = await Swal.fire({
      title: "Remove Image?",
      icon: "warning",
      showCancelButton: true
    });

    if (!confirm.isConfirmed) return;

    const updatedPreview = preview.filter(
      (_, i) => i !== index
    );

    const updatedFiles = pageimg.filter(
      (_, i) => i !== index
    );

    setPreview(updatedPreview);
    setPageimg(updatedFiles);

  };

  // =========================
  // EXTRA IMAGE ROWS
  // =========================

  // const addImageRow = () => {

  //   setImageRows([
  //     ...imageRows,
  //     {
  //       image: null,
  //       preview: "",
  //       altTitle: ""
  //     }
  //   ]);

  // };


  const addImageRow = () => {
  setImageRows([
    ...imageRows,
    {
      image: null,
      preview: "",
      altTitle: `${visaLink}-${imageRows.length + 1}`
    }
  ]);
};

  const removeImageRow = async (index) => {

    if (imageRows.length === 1) {
      toast.error("At least one row required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Delete Row?",
      icon: "warning",
      showCancelButton: true
    });

    if (!confirm.isConfirmed) return;

    const updated = imageRows.filter(
      (_, i) => i !== index
    );

    setImageRows(updated);

  };

  const handleRowImageChange = (
    index,
    file
  ) => {

    const updatedRows = [...imageRows];

    updatedRows[index].image = file;
    updatedRows[index].preview =
      URL.createObjectURL(file);

    setImageRows(updatedRows);

  };

  const handleAltTitleChange = (
    index,
    value
  ) => {

    const updatedRows = [...imageRows];

    updatedRows[index].altTitle = value;

    setImageRows(updatedRows);

  };

  // =========================
  // SAVE BLOG
  // =========================

  const saveBlog = async () => {

    if (!title) {
      toast.error("Title is required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Save Visa Assistance ?",
      text: "Do you want to save this Visa Assistance ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes Save"
    });

    if (!confirm.isConfirmed) return;
   setIsSubmitting(true);
    try {

      const visaLink = title
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-");

      const formData = new FormData();
      // BLOG DATA
formData.append("visaLink", visaLink);
formData.append("addedBy", addedBy);
formData.append("youTube_link", getYoutubeLink);
formData.append("addedDt", updatedDate);
formData.append("title", title);
formData.append("sbTitle", sbTitle);
formData.append("category", selectedCategory);
formData.append("description", description);
formData.append("pageContent", content);
formData.append("metaKey", metaKey);
formData.append("metaDescription",metaDescription);
formData.append("keyword", keyword);

imageRows.forEach((row, index) => {
  if (row.image) {
    formData.append("extraImages", row.image);
  }
  formData.append(
    `altTitle_${index}`,
    `${visaLink}-${index + 1}`
  );
});

const tabsData = tabs.map((tab) => ({
  tab_id: tab.tab_id,
  name: tab.name,
  checked: tabChecks[tab.tab_id] || false,
  content: tabContents[tab.tab_id] || ""
}));

formData.append("tabsData", JSON.stringify(tabsData));
formData.append("sratingPrice", getSratingPrice);
formData.append("processTime", getProcessTime);
formData.append("hourDays", getHourDays);
formData.append(
  "faqData",
  JSON.stringify(faqRows)
);
      // API
      const res = await api.post(
        "/adminVisaAssistanc/saveVisa",
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

      // SUCCESS
      if (res.data.success) {

        Swal.fire(
          "Success",
          "Visa Assistance Saved Successfully",
          "success"
        );
        navigate("/visa-assistance-manage");
        // RESET
        setTitle("");
        setSbTitle("");
        setDescription("");
        setYoutubeLink("");
        setContent("");

        setMetaKey("");
        setMetaDescription("");
        setKeyword("");

        setPageimg([]);
        setPreview([]);

        setImageRows([
          {
            image: null,
            preview: "",
            altTitle: ""
          }
        ]);

        // NAVIGATE TO BLOG MANAGE PAGE
        
      } else {
        Swal.fire(
          "Error",
          res.data.message,
          "error"
        );

      }

    } catch (error) {
      console.log(error);

      toast.error("Server Error");

    }
    finally {

    setIsSubmitting(false);

  }

  };

  // =========================
  // JSX
  // =========================


// FAQ AREA START//
const addFaqRow = () => {
  setFaqRows([
    ...faqRows,
    {
      question: "",
      answer: ""
    }
  ]);
};

const removeFaqRow = async (index) => {
  if (faqRows.length === 1) {
    toast.error("At least one FAQ required");
    return;
  }

  const confirm = await Swal.fire({
    title: "Delete FAQ?",
    icon: "warning",
    showCancelButton: true
  });

  if (!confirm.isConfirmed) return;

  setFaqRows(faqRows.filter((_, i) => i !== index));
};

const handleFaqChange = (index, field, value) => {
  const updatedRows = [...faqRows];

  updatedRows[index][field] = value;

  setFaqRows(updatedRows);
};
// FAQ AREA END//

  return (

    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}

      <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">

        <div className="card-body d-flex justify-content-between align-items-center">

          <h4 className="fw-bold mb-0">
            Add Visa Assistance
          </h4>

          <Link
            to="/visa-assistance-manage"
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
          >
            <ArrowLeft size={16} />
            Back
          </Link>

        </div>

      </div>

      <div className="row">

        {/* LEFT SIDE */}

        <div className="col-lg-12">

          <table className="table table-bordered">

            <tbody>

              {/* BLOG LINK */}

              {title.length > 0 && (

                <tr>

                  <th colSpan={2}>

                    <div className="d-flex align-items-center gap-2">

                      <i
                        className="fa fa-link text-primary"
                        aria-hidden="true"
                      ></i>

                      <input
                        type="text"
                        className="form-control"
                        readOnly
                        value={visaLink}
                      />

                    </div>

                  </th>

                </tr>

              )}
              
       
              {/* META Title */}

              <tr>
                <th colSpan={2}>   <div className="d-flex align-items-center gap-2">
                    <span>Meta Title</span>
                    <small className={`d-block mt-1 ${
  metaKey.length > 80 ? "text-danger" : "text-muted"
}`}>
  ({metaKey.length}/80 Characters)
</small>
               </div>
                </th>
              </tr>

              <tr>

                <td colSpan={2}>

                 <input
  type="text"
  className="form-control"
  placeholder="Enter Meta Title"
  value={metaKey}
  maxLength={80}
  onChange={(e) => setMetaKey(e.target.value)}
/>



{metaKey.length >= 79 && metaKey.length <= 80 && (
  <small className="text-danger">
    ⚠️ Almost reached limit
  </small>
)}

                </td>

              </tr>

              {/* META DESCRIPTION */}

              <tr>
                <th colSpan={2}>
                  <div className="d-flex align-items-center gap-2">
                    <span>Meta Description</span>
                    <small className={`d-block mt-1 ${
  metaDescription.length > 160 ? "text-danger" : "text-muted"
}`}>
  ({metaDescription.length}/160 Characters)
</small>
                  </div>
                  
                </th>
              </tr>

              <tr>

                <td colSpan={2}>

                  <textarea
                    rows="3"
                    className="form-control"
                    placeholder="Enter Meta Description"
                    value={metaDescription}
                    maxLength={160}
                    onChange={(e) =>
                      setMetaDescription(
                        e.target.value
                      )
                    }
                  ></textarea>


{metaDescription.length >= 159 && metaDescription.length <= 160 && (
  <small className="text-danger">
    ⚠️ Almost reached limit
  </small>
)}
                </td>

              </tr>

              {/* KEYWORD */}

              <tr>
                <th colSpan={2}>
                  <div className="d-flex align-items-center gap-2">
                 <span>Meta Keyword  </span><small className={`d-block mt-1 ${
  keyword.length > 255 ? "text-danger" : "text-muted"
}`}>
  ({keyword.length}/255 Characters)
</small>
</div>
                </th>
              </tr>

              <tr>

                <td colSpan={2}>

                 <textarea
                  rows="3"
                    className="form-control"
                    placeholder="Enter Keyword"
                    value={keyword}
                      maxLength={255}
                    onChange={(e) =>
                      setKeyword(
                        e.target.value
                      )
                    }
                  ></textarea>


{keyword.length >= 254 && keyword.length <= 255 && (
  <small className="text-danger">
    ⚠️ Almost reached limit
  </small>
)}
                </td>
</tr>
             
              
 <tr>
                <th colSpan={2}>Visa Country</th>
              
              </tr>
               <tr>

                <td colSpan={2}>
{/* <pre>{JSON.stringify(tabs, null, 2)}</pre> */}
        

<select
  className="form-control"
  value={selectedCategory}
  onChange={(e) => setSelectedCategory(e.target.value)}
>
  <option value="" hidden>-- Select Country --</option>

  {categories.map((cat) => (
    <option key={cat.cntry_id} value={cat.slug}>
      {cat.name}
    </option>
  ))}
</select>

                </td>

        

              </tr>
              {/* TITLE */}

              <tr>
                <th>Page Title</th>
                <th>Page Sub Title</th>
              </tr>

              <tr>

                <td>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter  Title"
                    value={title}
                    onChange={(e) =>
                      setTitle(e.target.value)
                    }
                  />

                </td>

                <td>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Sub Title"
                    value={sbTitle}
                    onChange={(e) =>
                      setSbTitle(e.target.value)
                    }
                  />

                </td>
                </tr>
    <tr>
                <th>Starting Price</th>
                <th>Processing Time</th>
              </tr>

               <tr>

                <td>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Starting Price"
                    value={getSratingPrice}
                    onChange={(e) =>
                      setSratingPrice(e.target.value)
                    }
                  />

                </td>

                <td style={{width:"50%"}}>
<div style={{display:"flex"}}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Processing Time"
                    value={getProcessTime}
                    onChange={(e) =>
                      setProcessTime(e.target.value)
                    }
                  />
<select className="form-control" style={{width:"20%"}}  onChange={(e) => setHourdays(e.target.value)}>
  <option hidden>- Select -</option>
  <option value="Hours">Hours</option>
  <option value="Days">Days</option>
</select>
</div>
                </td>
                </tr>

{/* TAB AREA START */}
                <tr>
                  <th colSpan={2}>Tab Datails</th>
                  </tr>
                   <tr>

                <td colSpan={2}>
    <div>
      {/* Tabs */}
      <ul className="nav nav-tabs">
        {tabs.map((tab) => (
          <li
            key={tab.tab_id}
     className={`custom-tab ${
    activeTab === tab.tab_id ? "tab-active" : "tab-inactive"
  }`}
            style={{ display: "inline-block" }}
          >
            <button
             onClick={() => setActiveTab(tab.tab_id)}
              style={{
                border: "none",
                background: "none",
                cursor: "pointer",
                padding: "5px",
              }}
            >
              {tab.name}
            </button>
          </li>
        ))}
      </ul>

      {/* Tab Content */}
        {/* Dynamic Content */}
      <div className="tab-content">
        {tabs.map((tab) =>
          activeTab === tab.tab_id ? (
            <div key={tab.tab_id}>
              <div  style={{display:"flex",backgroundColor:"#ff6c26",color:"#fff",fontWeight:"600",paddingLeft:"5px"}}>
                    <input
          type="checkbox"
        checked={tabChecks[tab.tab_id] || false}
onChange={(e) =>
  setTabChecks((prev) => ({
    ...prev,
    [tab.tab_id]: e.target.checked
  }))
}
        />
              <p style={{marginLeft:"5px",marginTop:"15px"}}>{tab.name}</p>
         
      </div>
                          
<CKEditor
  editor={ClassicEditor}
  data={tabContents[tab.tab_id] || ""}
  config={{
    licenseKey: "GPL",

    plugins: [
      Essentials,
      Paragraph,
      Heading,
      Bold,
      Italic,
      Underline,
      Font,
      Alignment,
      List,
      CKLink,
      BlockQuote,
      CKTable,
      TableToolbar,
      CKImage,
      ImageUpload,
      ImageToolbar,
      ImageStyle,
      ImageResize,
      SimpleUploadAdapter,
      HorizontalLine,
    ],

    toolbar: [
      "heading",
      "|",
      "bold",
      "italic",
      "underline",
      "|",
      "fontSize",
      "fontColor",
      "fontBackgroundColor",
      "|",
      "alignment",
      "|",
      "bulletedList",
      "numberedList",
      "|",
      "link",
      "blockQuote",
      "insertTable",
      "|",
      "imageUpload",
      "horizontalLine",
      "|",
      "undo",
      "redo",
    ],

    table: {
      contentToolbar: [
        "tableColumn",
        "tableRow",
        "mergeTableCells",
      ],
    },

    simpleUpload: {
      uploadUrl:
        "http://localhost:5000/api/upload-editor-image",
    },
  }}
  onChange={(event, editor) => {
    const data = editor.getData();

    setTabContents((prev) => ({
      ...prev,
      [tab.tab_id]: data,
    }));
  }}
/>

            </div>
          ) : null
        )}
      </div>
    </div>

                </td>
                </tr>
{/* TAB AREA END */}

{/* FAQ AREA START*/}
<tr>
<th colSpan={2}>FAQ Datails</th>
</tr>
<tr >
  <th colSpan={2}>
 <table className="table table-hover table-bordered align-middle mb-0">

                    <thead className="table-light">

                      <tr>
                        <th width="50">
                          #
                        </th>

                        <th>
                         Question
                        </th>

                        <th>
                          Answer
                        </th>

                        <th width="120">
                          Action
                        </th>
                      </tr>

                    </thead>

                    <tbody>
{faqRows.map((row, index) => (

                          <tr key={index}>

                            <td>
                              {index + 1}
                            </td>

                            <td>

                              <textarea
  className="form-control"
  placeholder="Enter Question"
  value={row.question}
  onChange={(e) =>
    handleFaqChange(
      index,
      "question",
      e.target.value
    )
  }
/>
                            

                            </td>

                            <td>
<textarea
  className="form-control"
  placeholder="Enter Answer"
  value={row.answer}
  onChange={(e) =>
    handleFaqChange(
      index,
      "answer",
      e.target.value
    )
  }
/>

                            </td>

                            <td>
<button
  type="button"
  className="btn btn-success btn-sm me-2"
  onClick={addFaqRow}
>
  <i className="fa fa-plus-square"></i>
</button>

<button
  type="button"
  className="btn btn-danger btn-sm"
  onClick={() => removeFaqRow(index)}
>
  <i className="fa fa-trash"></i>
</button>

                            </td>

                          </tr>

                        )
                      )}

                    </tbody>

                  </table>
  </th>
</tr>
{/* FAQ AREA START*/}
              
{/*YOU TUBE LINK AREA SRAER */}
 <tr>
                <th colSpan={2}>
                  You Tube Link
                </th>
              </tr>
              <tr>

                <td colSpan={2}>

                  <textarea
                    rows="4"
                    className="form-control"
                    placeholder="Enter You Tube Link"
                    value={getYoutubeLink}
                    onChange={(e) =>
                      setYoutubeLink(
                        e.target.value
                      )
                    }
                  ></textarea>

                </td>

              </tr>
{/* YOU TUBE LINK AREA END */}

              {/* DESCRIPTION */}

              <tr>
                <th colSpan={2}>
                  Page Description
                </th>
              </tr>

              <tr>

                <td colSpan={2}>

                  <textarea
                    rows="4"
                    className="form-control"
                    placeholder="Enter Description"
                    value={description}
                    onChange={(e) =>
                      setDescription(
                        e.target.value
                      )
                    }
                  ></textarea>

                </td>

              </tr>

              {/* CKEDITOR */}

              <tr>
                <th colSpan={2}>
                  Page Detailed Content
                </th>
              </tr>

              <tr>

                {/* <td colSpan={2}>

                  <CKEditor
                    editor={ClassicEditor}
                    data={content}
                    onChange={(
                      event,
                      editor
                    ) => {

                      const data =
                        editor.getData();

                      setContent(data);

                    }}
                      config={{
    simpleUpload: {
      uploadUrl:
        "http://localhost:5000/api/upload-editor-image"
    },

    toolbar: [
      "heading",
      "|",
      "bold",
      "italic",
      "link",
      "bulletedList",
      "numberedList",
      "|",
      "blockQuote",
      "insertTable",
      "undo",
      "redo"
    ]
  }}
                  />

                  

                </td> */}

                <td colSpan={2}>
  <CKEditor
    editor={ClassicEditor}
    data={content}
    config={{
      licenseKey: "GPL",
      plugins: [
        Essentials,
        Paragraph,
        Heading,
        Bold,
        Italic,
        Underline,
        Font,
        Alignment,
        List,
        CKLink,
        BlockQuote,
        CKTable,
        TableToolbar,
        CKImage,
        ImageUpload,
        ImageToolbar,
        ImageStyle,
        ImageResize,
        SimpleUploadAdapter,
        HorizontalLine,
      ],
      toolbar: [
        "heading", "|",
        "bold", "italic", "underline", "|",
        "fontSize", "fontColor", "fontBackgroundColor", "|",
        "alignment", "|",
        "bulletedList", "numberedList", "|",
        "link", "blockQuote", "insertTable", "|",
        "imageUpload", "horizontalLine", "|",
        "undo", "redo",
      ],
      table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
      },
      simpleUpload: {
        uploadUrl: "http://localhost:5000/api/upload-editor-image", // ✅ tumhara real backend endpoint
      },
    }}
    onChange={(event, editor) => {
      const data = editor.getData();
      setContent(data);
    }}
  />
</td>

              </tr>


              {/* EXTRA IMAGE TABLE */}

              <tr>

                <th colSpan={2}>

                  <table className="table table-hover table-bordered align-middle mb-0">

                    <thead className="table-light">

                      <tr>
                        <th width="50">
                          #
                        </th>

                        <th>
                          Upload Image
                        </th>

                        <th>
                          Alt Title
                        </th>

                        <th width="120">
                          Action
                        </th>
                      </tr>

                    </thead>

                    <tbody>

                      {imageRows.map(
                        (row, index) => (

                          <tr key={index}>

                            <td>
                              {index + 1}
                            </td>

                            <td>

                              <input
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={(e) =>
                                  handleRowImageChange(
                                    index,
                                    e.target
                                      .files[0]
                                  )
                                }
                              />

                            

                            </td>

                            <td>

                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Alt Title"
                                readOnly
                           value={row.altTitle}
                              />

                            </td>

                            <td>

                              <button
                                type="button"
                                className="btn btn-success btn-sm me-2"
                                onClick={
                                  addImageRow
                                }
                              >
                                <i className="fa fa-plus-square"></i>
                              </button>

                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() =>
                                  removeImageRow(
                                    index
                                  )
                                }
                              >
                                <i className="fa fa-trash"></i>
                              </button>

                            </td>

                          </tr>

                        )
                      )}

                    </tbody>

                  </table>

                </th>

              </tr>
           
<tr>
  <th colSpan={2}>Added By</th>
  </tr>
              <tr>
                <td colSpan={2}>
                 <input
  className="form-control"
  placeholder="Enter Name"
  type="text"
  value={addedBy}
  onChange={(e) =>
    setaddedBy(e.target.value)
  }
/>

                </td>
              
              </tr>

            </tbody>

          </table>

        </div>

        {/* RIGHT SIDE */}

      

        {/* SAVE BUTTON */}

        <div className="col-lg-12 text-center">

     <button
  className="btn btn-info text-white px-5 mt-3"
  onClick={saveBlog}
  disabled={isSubmitting}
>
  {isSubmitting ? (
    <>
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
      ></span>
      Submitting...
    </>
  ) : (
    "Save Visa Assistance"
  )}
</button>

        </div>

      </div>

    </div>

  );

};

export default AddBlogPage;